import React, { useContext, useEffect } from "react";
import ff from "../../../../util/fabric";
import { CanvasContext, ProductContext } from "../../provider";

interface CanvasHtmlElementProps {
  htmlCanvasId: string;
}

function CanvasHtmlElement({
  htmlCanvasId,
}: CanvasHtmlElementProps): JSX.Element {
  // contexts
  const { productType, printPaper } = useContext(ProductContext);
  const { canvasRef, originalCanvasSize, scaledCanvasSize } = useContext(
    CanvasContext
  );

  useEffect(() => {
    // has to run only once
    if (originalCanvasSize) {
      window.addEventListener("resize", windowResizeEvent);
      initialCanvasSize();
    }
  }, [originalCanvasSize]);

  function initialCanvasSize() {
    window.canvasRef.setWidth(scaledCanvasSize.width);
    window.canvasRef.setHeight(scaledCanvasSize.height);
  }

  function windowResizeEvent(): void {
    const { width } = window.canvasWrapRef.getBoundingClientRect();
    window.canvasRef.setWidth(width);
    window.canvasRef.setHeight(
      width * (scaledCanvasSize.height / scaledCanvasSize.width)
    );

    if (productType === "only-image" || productType === "pop-art") {
      ff.handleGridResize(
        canvasRef.current,
        originalCanvasSize.width / (printPaper.width / 1)
      );
      window.canvasRef.renderAll();
    } else if (productType === "kids") {
      ff.handleGridResize(canvasRef.current);
      window.canvasRef.renderAll();
    } else if (productType === "words") {
      ff.handleWordResize(canvasRef.current);
      window.canvasRef.renderAll();
    }
  }

  return <canvas id={htmlCanvasId} />;
}

export default CanvasHtmlElement;
